function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useState } from 'react';
import * as stylex from '@stylexjs/stylex';
import { AuthContext } from "src/session/AuthProvider";
import ColorIcon from "nood-comp/src/comp/ui/feather-icon/ColorIcon";
import Spacer from "nood-comp/src/comp/ui/spacer/Spacer";
import Text from "nood-comp/src/comp/text/Text";
import FlexVertical from "nood-comp/src/comp/ui/containers/flex-boxes/FlexVertical";
import Form from "nood-comp/src/comp/form/Form";
import Button from "nood-comp/src/comp/button/Button";
import { _get, _put, isHttpOK, isHttpWithData } from "nood-comp/src/net/xhr";
import { PublicPageContext } from "src/session/PublicPage";
import { useURLParam } from "nood-comp/src/hooks/useURLParam";
import FlexCenterCenter from "nood-comp/src/comp/ui/containers/FlexCenterCenter";
import SpinnerApple from "nood-comp/src/comp/ui/spinner/Spinner.Apple";
import TextField from "nood-comp/src/comp/form/textfield/TextField";
import Row from "nood-comp/src/comp/ui/containers/flex-boxes/Row";
import DeviceAwareDiv400 from "nood-comp/src/comp/ui/containers/DeviceAwareDiv400";
import { __feedback } from "src/app/msg";
import { NavLink } from "react-router-dom";
import Flex from "nood-comp/src/comp/ui/containers/Flex";
import Icon from "nood-comp/src/comp/ui/feather-icon/Icon";
export default function AdminInviteIndex(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    adminSignupForm = _useState2[0],
    setAdminSignupForm = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    isValid = _useState4[0],
    setIsValid = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    isProcessing = _useState6[0],
    setIsProcessing = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    adminUserFromKey = _useState8[0],
    setAdminUserFromKey = _useState8[1];
  var _useState9 = useState(),
    _useState0 = _slicedToArray(_useState9, 2),
    errors = _useState0[0],
    setErrors = _useState0[1];
  var _useContext = useContext(AuthContext),
    user = _useContext.user,
    setUser = _useContext.setUser,
    invalidate = _useContext.invalidate;
  var publicPageContext = useContext(PublicPageContext);
  var key = useURLParam('key');

  // invalidate current admin session if this invitee is some sort of another
  // admin user
  useEffect(function () {
    if (user) {
      setUser(null);
      invalidate();
    }
  }, [user]);
  useEffect(function () {
    if (key) {
      publicPageContext.__getPublicToken(function () {
        _get("/adminuser-key?key=".concat(key), function (res) {
          if (isHttpOK(res)) {
            var _isHttpWithData, _isHttpWithData2;
            setAdminUserFromKey((_isHttpWithData = isHttpWithData(res)) !== null && _isHttpWithData !== void 0 ? _isHttpWithData : {});
            setAdminSignupForm((_isHttpWithData2 = isHttpWithData(res)) !== null && _isHttpWithData2 !== void 0 ? _isHttpWithData2 : {});
          } else {
            var _res$error;
            setErrors([].concat(_toConsumableArray(errors !== null && errors !== void 0 ? errors : []), _toConsumableArray((_res$error = res.error) !== null && _res$error !== void 0 ? _res$error : [])));
          }
        });
      });
    }
  }, [key]);
  var _submit = function _submit(submitCallback) {
    if (isValid && !isProcessing) {
      setIsProcessing(true);
      publicPageContext.__getPublicToken(function () {
        _put("/admin-invite", _objectSpread(_objectSpread({}, adminSignupForm), {}, {
          key: key
        }), function (res) {
          setIsProcessing(false);
          __feedback(res);
          submitCallback === null || submitCallback === void 0 || submitCallback(res);
        });
      });
    }
  };
  if ((errors === null || errors === void 0 ? void 0 : errors.length) > 0) {
    throw new Error(errors.join(";"));
  }
  if (adminUserFromKey === void 0 || adminUserFromKey === null) {
    return /*#__PURE__*/React.createElement(FlexCenterCenter, null, /*#__PURE__*/React.createElement(SpinnerApple, {
      size: 25,
      strokeSize: 1.5
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DeviceAwareDiv400, {
    pad: 20
  }, /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  }), /*#__PURE__*/React.createElement(Row, {
    gap: 20
  }, /*#__PURE__*/React.createElement(ColorIcon, {
    icon: "user",
    size: 70
  }), /*#__PURE__*/React.createElement(FlexVertical, {
    gap: 2
  }, /*#__PURE__*/React.createElement(Text, {
    size: 20
  }, "Create Admin Account"), /*#__PURE__*/React.createElement(Text, {
    secondary: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, "You were invited as admin of ", process.env.__APP_NAME, ".")))), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 30
  }), /*#__PURE__*/React.createElement(Form, {
    obj: adminSignupForm,
    __setter: setAdminSignupForm,
    __validSetter: setIsValid,
    __submit: function __submit(obj, errors, submitCallback) {
      _submit(submitCallback);
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    name: "email_address",
    label: "Email Address",
    disabled: true,
    validations: ['required'],
    spacer: 8,
    icon: "inbox"
  }), /*#__PURE__*/React.createElement(TextField, {
    name: "username",
    label: "Username",
    icon: "tag",
    validations: ['required', 'min_len=3'],
    spacer: 8
  }), /*#__PURE__*/React.createElement(TextField, {
    name: "display_name",
    label: "Display Name",
    icon: "user",
    spacer: 20
  }), /*#__PURE__*/React.createElement(TextField, {
    name: "password",
    label: "Password",
    icon: "key",
    validations: ['required'],
    spacer: 8,
    password: true
  }), /*#__PURE__*/React.createElement(TextField, {
    name: "confirm_password",
    label: "Confirm Password",
    icon: "key",
    validations: ['required'],
    spacer: 20,
    password: true
  }), /*#__PURE__*/React.createElement(Button, {
    label: "Signup as Admin",
    icon: "plus",
    disabled: !!(!isValid || isProcessing)
  }), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 20
  }), /*#__PURE__*/React.createElement(NavLink, {
    to: "/login"
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: 8
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    icon: "arrow-left"
  })), /*#__PURE__*/React.createElement("div", null, "Login"))))));
}
AdminInviteIndex.propTypes = {
  // proptypes
};

// @ts-ignore